import React from "react";

export const EmailIcon = () => {
  return (
    <svg width="72" height="71" viewBox="0 0 72 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="35.9475" cy="35.3889" r="35.3889" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9983 25.4131H45.8592C46.9822 25.3834 48.0804 25.7616 48.9683 26.4839L47.8366 27.2544L35.8914 35.3244L32.7823 33.2025C32.7183 33.1384 32.642 33.0894 32.5585 33.0588L24.0147 27.2478L22.8892 26.4839C23.7639 25.7358 24.8714 25.3543 25.9983 25.4131ZM22.108 27.4901L23.1589 28.2083L31.3732 33.8169L23.2335 42.6965L22.3505 43.6563C21.737 42.7568 21.4145 41.6743 21.4302 40.568L21.4365 30.1932C21.4277 29.2455 21.6595 28.3124 22.108 27.4901ZM47.7647 43.5779L39.4634 34.5416L36.2921 36.6962L36.1864 36.7484H36.1366C36.085 36.7553 36.0328 36.7553 35.9812 36.7484C35.9296 36.7553 35.8773 36.7553 35.8257 36.7484H35.776L35.6267 36.6962L32.4803 34.5546L24.1355 43.6041L23.2401 44.5769C24.0613 45.1316 25.0252 45.4073 26.001 45.3669H45.8992C46.8711 45.3735 47.8239 45.0831 48.6415 44.5312L47.7647 43.5779ZM50.4644 30.2116V40.5668C50.5061 41.6708 50.1904 42.757 49.569 43.6486L48.6798 42.6758L40.5464 33.7895L48.7544 28.2071L49.8115 27.4954C50.2661 28.3192 50.4922 29.2599 50.4644 30.2116Z"
        fill="white"
      />
    </svg>
  );
};
